import { NavLink } from "react-router-dom";
import { Icon } from "@shared/ui";
import { useNavigate } from "../hooks/useNavigate"; // Import our custom useNavigate hook

const NavItem = ({ to, label, icon, className = "", ...props }) => {
  const navigate = useNavigate(); // Use our custom navigate hook

  const handleClick = (e) => {
    e.preventDefault(); // Prevent default navigation

    // Use our custom navigate function to ensure client ID is preserved
    navigate(to);
  };

  return (
    <NavLink
      to={to}
      onClick={handleClick} // Add click handler to control navigation
      className={({ isActive }) =>
        `flex items-center px-3 py-2.5 gap-x-3 rounded hover:bg-gray-100 ${
          isActive && "bg-gray-100"
        } ${className}`
      }
      {...props}
    >
      {({ isActive }) => (
        <>
          <Icon
            icon={icon}
            height="h-4"
            width="w-4"
            className={isActive ? "fill-black" : "fill-gray-400"}
          />
          <h3
            className={`${
              isActive ? "text-black" : "text-gray-400"
            } font-medium`}
          >
            {label}
          </h3>
        </>
      )}
    </NavLink>
  );
};

export default NavItem;
